import { UserChapterProgress } from '@/types';

import { selectPlayerSessionDetailState } from '../player-fsm';
import { RootState } from '../store';

/**
 * Selects array of all Chapters of an Episode
 *
 * For Player Session it selects from the playerSessionDetailAdapter, so it streams in FSM updates automatically
 */
export const selectEpisodeProgress = (
  state: RootState,
  episodeId: string,
): UserChapterProgress[] | undefined => {
  const { chapters: userChapters } =
    selectPlayerSessionDetailState(state, episodeId) || {};
  return userChapters;
};

/**
 * Selects a specific Chapter
 *
 * For Player Session it selects from the playerSessionDetailAdapter, so it streams in FSM updates automatically
 * */
export const selectChapterProgress = (
  state: RootState,
  { episodeId, chapterId }: { episodeId: string; chapterId: string },
): UserChapterProgress | undefined => {
  return selectEpisodeProgress(state, episodeId)?.find(u => u.id === chapterId);
};
